import { BlobResponse, RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoint } from './constants';

export const api = {

  loadExportStatus: async (): Promise<any[]> => {
    const response = await new RemoteData(endpoint.loadExportStatus)
      .resource<ApiResponse<any[]>>()
      .single();
    return response.data;
  },

  downloadCaseExportPackage: async (exportId: string): Promise<BlobResponse> => {
    return await new RemoteData(endpoint.downloadCaseExportPackage)
      .resource<Blob>()
      .filter({ exportId })
      .blob();
  }
};
